export default __webpack_public_path__ + "static/media/martin_seriepatia.98b670ba.jpg";